// Theme
import '@styles/shopify.css'

// Scripts
import siteHeader from '@scripts/components/site-header'
import slideToggle from '@scripts/components/slide-toggle'

siteHeader.init()
slideToggle.init()

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 500)
})
